import * as React from "react";
const SvgCompanionDiagnostics = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color}
      strokeLinejoin="round"
      d="m8.488 8.607 7.453 6.953"
    />
    <path
      stroke="#061C57"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m20.318 3.685-.003-.003a5.207 5.207 0 0 0-7.363 0l-9.27 9.27a5.207 5.207 0 0 0 0 7.364l.003.002a5.207 5.207 0 0 0 7.363 0l9.27-9.27a5.207 5.207 0 0 0 0-7.363Z"
    />
  </svg>
);
export default SvgCompanionDiagnostics;
